import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import hoverStyles from './style/hover.css';
import generalStyles from './style/general.css';

export default function ButtonDivider({ hover, isActive }) {
  const classes = cx(generalStyles.divider, hoverStyles[hover], {
    'opacity-0': !isActive,
  });
  return <div className={classes} />;
}

ButtonDivider.propTypes = {
  hover: PropTypes.oneOf(Object.keys(hoverStyles)),
  isActive: PropTypes.bool,
};

ButtonDivider.propTYpes = {
  hover: 'blue',
  isActive: false,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/ButtonDivider/index.js